import React from 'react';
// @ts-ignore
import { TermsAndConditionsPage } from 'zerocode';

const TermsAndConditions = () => {
	return <TermsAndConditionsPage app="workflux" />;
};

export default TermsAndConditions;
